import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import _ from 'lodash';
import { setResolutions } from '../slices/resolutions';
import { setCurrentWorkspaceResolutionsIds } from '../slices/currentWorkspace';

export const getResolutionsByWorkspace = createAsyncThunk(
  'resolutions/getResolutionsByWorkspace',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;

    if (!_.isEmpty(workspaceId)) {
      setLoading(true);
      try {
        const response = await api.workspace.getResolutionsByWorkspaceId({
          workspaceId,
        });

        if (
          response.data.getMonitoringResolutionByWorkspaceId
            ?.monitoringResolutions
        ) {
          dispatch(
            setResolutions(
              response.data.getMonitoringResolutionByWorkspaceId
                .monitoringResolutions
            )
          );

          dispatch(
            setCurrentWorkspaceResolutionsIds(
              response.data.getMonitoringResolutionByWorkspaceId.monitoringResolutions.map(
                (resolution) => resolution.id
              )
            )
          );

          setLoading(false);
          return response.data.getMonitoringResolutionByWorkspaceId
            .monitoringResolutions;
        }
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
        return null;
      }
    } else {
      setErrors('generalError');
      setLoading(false);
      return null;
    }
    return null;
  }
);

export const createResolution = createAsyncThunk(
  'resolutions/createResolution',
  async (payload) => {
    const resolutionCreated = await api.resolution.createResolution({
      data: payload,
    });
    return resolutionCreated.data.createMonitoringResolution; // cambiar esto en query gql?
  }
);

export const deleteResolutionById = createAsyncThunk(
  'resolutions/deleteResolutionById',
  async (payload) => {
    const { id } = payload;
    const resolutionDeleted = await api.resolution.deleteResolutionById({ id });
    return resolutionDeleted.data.deleteMonitoringResolutionById;
  }
);

export const updateResolutionById = createAsyncThunk(
  'resolutions/updateResolutionById',
  async (payload) => {
    const { id, data } = payload;
    const resolutionUpdated = await api.resolution.updateResolutionById({
      id,
      data,
    });

    return resolutionUpdated.data.updateMonitoringResolutionById;
  }
);
